// React imports
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

// General imports
import _ from 'lodash';
import axios from 'axios';
import dayjs from 'dayjs';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

function CargoFive() {
    const { accesstoken } = useOutletContext();
    const [ cargofiveImports, setCargofiveImports ] = useState({});
    const [ orgs, setOrgs ] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axios.get(`/api/rates/import?accesstoken=${accesstoken}`);
                const _cargofiveImports = _.mapValues(data, (v) => v.filter(r => !!r.cargofiveData));
                setCargofiveImports(_cargofiveImports);

                const organizations = _.keys(_cargofiveImports).filter(k => _cargofiveImports[k].length > 0);
                const orgData = (await Promise.all(organizations.map(async (org) => {
                    const { data } = await axios.get(`/api/organizations/${org}?accesstoken=${accesstoken}`);
                    return { [org]: data };
                }))).reduce((acc, curr) => ({ ...acc, ...curr }), {});

                setOrgs(orgData);
            } catch (e) {
                console.error('Error fetching cargofive imports', e);
            }
        })();
    }, [accesstoken]);

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableCell>
                        Month
                    </TableCell>
                    <TableCell>
                        Number of Imports
                    </TableCell>
                </TableHead>
                <TableBody>
                    {_.keys(orgs).map((org) => ([
                        <TableRow key={org}>
                            <TableCell colSpan={2}><b>{orgs[org].title}</b> ({orgs[org].alias})</TableCell>
                        </TableRow>,
                        ...(() => {
                            const grouped = _.groupBy(cargofiveImports[org], (r) => dayjs(r.created).get('year') * 12 + dayjs(r.created).get('month'));
                            return _.reverse(_.range(2025 * 12 + 4, new Date().getFullYear() * 12 + new Date().getMonth() + 1)).map((i) => {
                                const month = i % 12;
                                const year = Math.floor(i / 12);
                                return (
                                    <TableRow key={i}>
                                        <TableCell>{_.padStart(month + 1, 2, '0')}/{year}</TableCell>
                                        <TableCell>{grouped[i]?.length || 0}</TableCell>
                                    </TableRow>
                                );
                            });
                        })()
                    ]))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default CargoFive;